import { FeedbackProjection } from "../../../projection/feedback/feedback";

const feedback: FeedbackProjection = {
  ["0ad1dba8-b02c-4121-a1e3-981f1c30800d"]: "9251dc2c-d76a-484d-9299-346929af932f",
  ["542c4d24-e1da-484f-8c3a-7d89ee135adc"]: "68c0bb98-b00a-4b86-af43-528fe903cb69",
  ["1123a37d-bc00-43a4-9d28-cee1dfaf356c"]: "Free text comment",
};

export { feedback };
